import React, { Component } from 'react';
import Button from '@tencent/dui/lib/components/Button';
import Style from './index.less';

type IResetBtnProps = {
    disabled?: boolean;
    text: string;
    onClick: () => void;
};

export default class FormBtn extends Component<IResetBtnProps> {
    public render() {
        return (
            <Button className={Style['reset-btn']} onClick={this.props.onClick} disabled={this.props.disabled}>
                {this.props.text}
            </Button>
        );
    }
}
